import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuTrigger,
} from '@heidi/design-system/context-menu';
import { SidebarMenuAction, SidebarMenuBadge } from '@heidi/design-system/page-shell';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { ReactNode } from 'react';

import type { NavItemProps } from './nav-item.types';

export function NavItemMenuTrailing({
  panelToggle,
  isMobile,
  mobilePanelContent,
  mobilePanelAction,
  openPanel,
  label,
  badge,
  action,
  belowContent,
}: {
  panelToggle: NavItemProps['panelToggle'];
  isMobile: boolean;
  mobilePanelContent: NavItemProps['mobilePanelContent'];
  mobilePanelAction: NavItemProps['mobilePanelAction'];
  openPanel: (content: ReactNode, action?: ReactNode) => void;
  label: string;
  badge: ReactNode;
  action: ReactNode;
  belowContent: ReactNode;
}): ReactNode {
  return (
    <>
      {panelToggle ? (
        <SidebarMenuAction
          showOnHover
          onClick={() => {
            if (isMobile && mobilePanelContent) {
              openPanel(mobilePanelContent, mobilePanelAction);
            } else {
              panelToggle.onToggle();
            }
          }}
          aria-label={
            panelToggle.ariaLabel ||
            (panelToggle.isOpen ? `Close ${label} panel` : `Open ${label} panel`)
          }
        >
          {panelToggle.isOpen && !isMobile ? (
            <ChevronLeft className="rtl:-scale-x-100" />
          ) : (
            <ChevronRight className="rtl:-scale-x-100" />
          )}
        </SidebarMenuAction>
      ) : null}
      {badge ? <SidebarMenuBadge>{badge}</SidebarMenuBadge> : null}
      {action}
      {belowContent}
    </>
  );
}

/** Wraps a `SidebarMenuItem` so the whole row is a right-click target. */
export function NavItemRowContext({
  children,
  menu,
}: {
  children: ReactNode;
  menu: ReactNode | undefined;
}): ReactNode {
  if (!menu) {
    return children;
  }

  return (
    <ContextMenu>
      <ContextMenuTrigger asChild>{children}</ContextMenuTrigger>
      <ContextMenuContent onClick={(event) => event.stopPropagation()}>
        {menu}
      </ContextMenuContent>
    </ContextMenu>
  );
}
